"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Racquet = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Racquet, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Racquet);

  function Racquet() {
    (0, _classCallCheck2["default"])(this, Racquet);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Racquet, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M18.19,14.9757289 C20.399139,14.9757289 22.19,16.7665899 22.19,18.9757289 C22.19,21.1848679 20.399139,22.9757289 18.19,22.9757289 C15.980861,22.9757289 14.19,21.1848679 14.19,18.9757289 C14.19,16.7665899 15.980861,14.9757289 18.19,14.9757289 L18.19,14.9757289 Z M18.19,16.9757289 C17.0854305,16.9757289 16.19,17.8711594 16.19,18.9757289 C16.19,20.0802984 17.0854305,20.9757289 18.19,20.9757289 C19.2945695,20.9757289 20.19,20.0802984 20.19,18.9757289 C20.19,17.8711594 19.2945695,16.9757289 18.19,16.9757289 L18.19,16.9757289 Z M6.24,14.5157289 C6.24,14.5157289 7.65,13.0957289 7.66,10.2757289 C7.3,8.08572889 8.16,5.51572889 10.13,3.55572889 C13.06,0.625728894 17.33,0.145728894 19.69,2.47572889 C22.02,4.83572889 21.54,9.10572889 18.61,12.0357289 C16.65,14.0057289 14.08,14.8657289 11.89,14.5057289 C9.07,14.5157289 7.65,15.9257289 7.65,15.9257289 L3.41,20.1657289 L2,18.7557289 L6.24,14.5157289 L6.24,14.5157289 Z M18.26,3.90572889 C16.69,2.34572889 13.69,2.81572889 11.54,4.97572889 C9.4,7.11572889 8.92,10.1257289 10.48,11.6857289 C12.05,13.2457289 15.05,12.7657289 17.19,10.6257289 C19.35,8.47572889 19.82,5.47572889 18.26,3.90572889 Z"
      }));
    }
  }]);
  return Racquet;
}(_react["default"].PureComponent);

var _default = Racquet;
exports["default"] = _default;